import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { BandejaService } from '../../services/bandeja.service';
import { PersonaService } from '../../services/persona.service';
import { NavbarService } from '../navbar/navbar.service';
import {ArchivosNivel4AutocompleteModule} from "./archivos-nivel4-autocomplete.module";
import {ArchivoCentralService} from "../../services/archivo-central.service";

@Component({
  selector: 'app-archivos-4-autocomplete',
  templateUrl: './archivos-nivel4-autocomplete.component.html',
  styleUrls: ['./archivos-nivel4-autocomplete.component.scss']
})
export class ArchivosNivel4AutocompleteComponent implements OnInit, OnDestroy {

  @Input('control') control: FormControl

  @Input('nivel1') nivel1: string

  @Input('nivel2') nivel2: string

  @Input('nivel3') nivel3: string

  @Input('label') label: string

  @Input('placeholder') placeholder: string

  @Input('disable') set disable(value: boolean) {
    if (value) {
      this.inputControl.enable();
    } else {
      this.control.setValue('');
      this.inputControl.setValue('');
      this.inputControl.disable();
    }
  }

  @Output('onOptionSelected') onOptionSelected = new EventEmitter<RemitentePorArea>()

  inputControl = new FormControl({value: ''})

  options: RemitentePorArea[] = []

  optionSelected: RemitentePorArea;

  loading = false;

  optionsEmpty = false;

  private _subs = new Subscription()

  constructor(
    private _navbarService: NavbarService,
    private _bandejaService: BandejaService,
    private _archivoService: ArchivoCentralService,
  ) { }

  ngOnInit(): void {
    if (!this.nivel3) {
      this.inputControl = new FormControl({ value: '', disabled: true });
    }

    const inputSub = this.inputControl.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      if (value == '') {
        this.control.setValue('')
        /*this.options = []
        return*/
      }

      this.loading = true
      this.optionsEmpty = false;
      this.options = []

      this._archivoService.getArchivoslistaNivel4({
        criterio: value, nivel1: this.nivel1, nivel2: this.nivel2, nivel3: this.nivel3
      }).then((list: any) => {
        this.options = list
        this.loading = false
        this.optionsEmpty = !Boolean(list.length)
      })
    });
    this._subs.add(inputSub)

    /*const controlSub = this.control.valueChanges.subscribe(value => {
      if (!value) this.inputControl.setValue('');
    });
    this._subs.add(controlSub)*/
  }

  ngOnDestroy(){
    this._subs.unsubscribe()
  }

  setOptionSelected(event) {
    this.optionSelected = event.option.value

    this.onOptionSelected.emit(this.optionSelected)

    const label = event.option.value

    this.inputControl.setValue(label)
    this.control.setValue(label)

  }

  onFocus() {
    this.options = []
    this.optionsEmpty = false;

    this.inputControl.setValue('')
  }

  cleanControl() {
    this.inputControl.setValue('')
    this.control.setValue('')
  }
}

export interface RemitentePorArea {
  cargo: string
  idPersona: number
  nombresCompletos: string
  username: string
  usernamePadre: string
  label?: string
}
